import * as angular from 'angular';

import {
  convertColFromPivotToFlamingo,
  getDefaultFieldFormatMapFromColumns,
  getDefaultGeneralFormat,
  getDefaultTableColumnSettingsFromColumns,
} from '@mode/shared/util-js';
import { ChartTypes, FlamingoTypes, ChartDataTypes } from '@mode/shared/contract-common';
import { generateFormatFromFlatTableFormat } from '@mode/shared/util-js';

export class PivotResultsDataGridController {
  // bindings
  private dataset: ChartDataTypes.Dataset;

  // local state
  private format: ChartTypes.ChartFormat;
  private fieldFormats: ChartTypes.FieldFormatMap;
  private content: ChartDataTypes.Dataset['content'];
  private columns: FlamingoTypes.RecordsResult['columns'];

  $onChanges(changes: angular.IOnChangesObject) {
    const datasetChanged =
      changes.dataset && !angular.equals(changes.dataset.currentValue, changes.dataset.previousValue);

    if (this.dataset && datasetChanged) {
      // transform columns to flamingo columns
      this.columns = this.dataset.columns.map((column) => convertColFromPivotToFlamingo(column));

      this.content = angular.copy(this.dataset.content);

      // Set table format
      let general = getDefaultGeneralFormat(ChartTypes.FlatTableDefaultGeneralFormat.Results);
      general = {
        ...general,
        sizingStyle: 'sizeToFit',
      };
      this.format = generateFormatFromFlatTableFormat({
        general: general,
        columns: getDefaultTableColumnSettingsFromColumns(this.columns),
      });
      this.fieldFormats = getDefaultFieldFormatMapFromColumns(this.columns);
    }
  }
}

export const PivotResultsDataGridComponent: angular.IComponentOptions = {
  bindings: {
    dataset: '<',
  },

  controller: PivotResultsDataGridController,
  controllerAs: 'ctrl',

  template: `
    <div class="view-data-table-container">
      <mode-flat-table-ng
        ng-if="ctrl.dataset.state === 'succeeded'"
        [columns]="ctrl.columns"
        [content]="ctrl.content"
        [format]="ctrl.format"
        [field-formats]="ctrl.fieldFormats"
        [expandable-cell-contents]="true"
      ></mode-flat-table-ng>

      <!-- Intermediary Messages Begin -->
      <div ng-if="ctrl.dataset.state === 'empty'" class="error-message">
        <div class="message">No rows in dataset</div>
      </div>
      <!-- @Intermediary Messages End -->
    </div>
  `,
};
